import "./Dossier.css"
import {useEffect, useState} from "react";
import {Input, Table} from "antd";
import UserDetailsButton from "../userDetails/UserDetailsButton";
import {HttpService} from "../../services/http/Http.service";
import {UtilsService} from "../../services/Utils.service";
import {SearchOutlined} from "@ant-design/icons";
import {Person} from "../../model/models";
import {HttpErrorService} from "../../services/http/HttpError.service";

export default function Dossier() {
    const [searchText, setSearchText] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [filteredData, setFilteredData] = useState<Person[]>([]);

    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;

    const columns = [
        {title: "Nome", dataIndex: "firstName", key: "firstName"},
        {title: "Cognome", dataIndex: "lastName", key: "lastName"},
        {title: "Codice Fiscale", dataIndex: "fiscalCode", key: "fiscalCode"},
        {
            title: "Data di Nascita", key: "dateOfBirth",
            render: ((record: any) => record.dateOfBirth !== null ? UtilsService.formatDateString(record.dateOfBirth) : "-")
        },
        {
            title: "Indirizzo", key: "residence", render: (record: Person) => {
                return record.residenceAddress + " " + record.residenceHouseNumber
            }
        },
        {title: "CAP", dataIndex: "residencePostalCode", key: "residencePostalCode"},
        {title: "Città", dataIndex: "residenceCity", key: "residenceCity"},
        {title: "Provincia", dataIndex: "residenceProvince", key: "residenceProvince"},
        {
            title: "Azioni", key: "operation", render: (record: Person) =>
                <UserDetailsButton personID={record.id}></UserDetailsButton>
        }
    ];

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearchText(value);
        sessionStorage.setItem("dossierSearchText", value);
    };

    useEffect(() => {
        const savedSearchText = sessionStorage.getItem("dossierSearchText") || "";
        setSearchText(savedSearchText);

        if (savedSearchText.length >= 3) {
            setDebouncedSearch(savedSearchText);
        }
    }, []);

    useEffect(() => {
        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            event.preventDefault();
        };

        const handleUnload = () => {
            sessionStorage.removeItem("dossierSearchText");
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        window.addEventListener("unload", handleUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
            window.removeEventListener("unload", handleUnload);
        };
    }, []);


    useEffect(() => {
        if (searchText.length < 3) {
            sessionStorage.removeItem("dossierSearchText");
            setFilteredData([]);
            setTotalItems(0);
        }
    }, [searchText]);

    useEffect(() => {
        const handler = setTimeout(() => {
            if (searchText.length >= 3) {
                setDebouncedSearch(searchText);
            }
        }, 500);

        return () => clearTimeout(handler);
    }, [searchText]);

    useEffect(() => {
        if (debouncedSearch) {
            searchData(debouncedSearch);
        }
    }, [debouncedSearch, currentPage]);

    const searchData = async (query: string) => {
        try {
            const urlEncodedQuery = encodeURIComponent(query);
            const response = await HttpService.getInstanceAxios().get(`/person/searchBy?userInput=${urlEncodedQuery}&showDeceased=true`, {
                params: {
                    page: currentPage - 1,
                    size: pageSize
                }
            });
            setFilteredData(response.data.content)
            setTotalItems(response.data.totalElements);
        } catch (error) {
            HttpErrorService.handle('Errore durante la ricerca.', error, true)
        }
    };

    return (
        <>
            <div className={"container-search"}>
                <Input size="large"
                       style={{width: "100%", maxWidth: "480px"}}
                       allowClear
                       value={searchText}
                       onChange={handleChange}
                       addonBefore={<SearchOutlined />}
                       placeholder="Nome, Cognome, Codice Fiscale, Numero Protocollo"
                />
            </div>
            <Table
                dataSource={filteredData}
                columns={columns}
                rowKey="id"
                pagination={{
                    showSizeChanger: false,
                    current: currentPage,
                    pageSize: pageSize,
                    total: totalItems,
                    onChange: (page) => setCurrentPage(page)
                }}
            />


        </>
    )
}
